<template>
  <div class="page rules">
    <Header header="rules"></Header>
    <div class="rules-policy py-5">
      <b-container class="content-normal">
        <div v-html="getPage['content']"></div>
      </b-container>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
export default {
  name: 'Rules',
  components: { Footer, Header },
  computed: {
    getPage () {
      return this.$store.getters.getPage('rules')
    }
  }
}
</script>

<style scoped>

</style>
